import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'

class ErrorBoundary extends React.Component {
    state = { hasError: false }

    static getDerivedStateFromError() {
        return { hasError: true }
    }

    componentDidCatch(error) {
        console.error('[ErrorBoundary]', error)
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    backgroundColor: 'white',
                    fontFamily: 'Montserrat, sans-serif',
                    textAlign: 'center',
                    padding: '20px'
                }}>
                    <p style={{ fontSize: '18px', color: '#333' }}>
                        Ocurrió un error inesperado. Si usas una extensión de traducción
                        (Google Translate, Linguist), desactívala para esta página.
                    </p>
                    <button
                        onClick={() => window.location.reload()}
                        style={{
                            padding: '10px 24px',
                            fontSize: '16px',
                            backgroundColor: 'black',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer'
                        }}
                    >
                        Recargar
                    </button>
                </div>
            )
        }
        return this.props.children
    }
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
    <ErrorBoundary>
        <App/>
    </ErrorBoundary>
)
